import { useRef } from "react";

export interface DebugOverlayProps {
  audioUrl: string;
  audioInfo: {
    size: number;
    type: string;
    duration: number;
    recordingStatus: string;
  } | null;
  onClose: () => void;
}

export function DebugOverlay({
  audioUrl,
  audioInfo,
  onClose,
}: DebugOverlayProps) {
  const audioRef = useRef<HTMLAudioElement>(null);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: "rgba(0, 0, 0, 0.85)",
        color: "white",
        padding: "15px 20px",
        zIndex: 10000,
        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.3)",
        fontFamily: "monospace",
        fontSize: "12px",
      }}
    >
      <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <strong style={{ fontSize: "14px" }}>🎙️ DEBUG: Last Recording</strong>
          <button
            onClick={onClose}
            style={{
              background: "rgba(255, 255, 255, 0.2)",
              border: "none",
              color: "white",
              padding: "5px 10px",
              cursor: "pointer",
              borderRadius: "3px",
              fontSize: "12px",
            }}
          >
            ✕ Close
          </button>
        </div>

        {audioInfo && (
          <div style={{ marginBottom: "10px", opacity: 0.8 }}>
            Size: {(audioInfo.size / 1024).toFixed(2)} KB | Type:{" "}
            {audioInfo.type} | Duration: {audioInfo.duration.toFixed(2)}s |
            Status: {audioInfo.recordingStatus}
          </div>
        )}

        <audio
          ref={audioRef}
          src={audioUrl}
          controls
          style={{
            width: "100%",
            height: "40px",
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            borderRadius: "5px",
          }}
        />

        {/* Download link for the recorded audio */}
        <div style={{ marginTop: "10px" }}>
          <a
            href={audioUrl}
            download="recording.webm"
            style={{
              display: "inline-block",
              backgroundColor: "rgba(255, 255, 255, 0.2)",
              color: "white",
              padding: "8px 15px",
              textDecoration: "none",
              borderRadius: "3px",
              fontSize: "12px",
              textAlign: "center",
              width: "100%",
              maxWidth: "200px",
              margin: "0 auto",
            }}
          >
            📥 Download Recording
          </a>
        </div>
      </div>
    </div>
  );
}
